import 'arrive';

let currentType = 'page';
let currentPage = 1;
let isLoading = false;
let controller = null;

const getSearchTerm = () => {
  const form = document.querySelector('.block-page-banner__search');
  const input = form?.querySelector('input[name="q"]');
  console.log("INPUT VALUE RAW:", input?.value);
  return input?.value.trim() || '';
};

function toggleLoadButton(state) {
  const btn = document.querySelector('.btn-load');
  if (!btn) return;
  btn.style.display = (state === 'hide') ? 'none' : 'inline-flex';
  btn.disabled = (state === 'loading' || state === 'hide');
}

function updateUI(res, reset) {
  const list = document.querySelector('.block-page-results__list');
  if (!list) return;

  // Aggiorna i conteggi anche se non ci sono risultati
  updateCounts(res.data?.counts);

  if (reset) list.innerHTML = '';

  if (res.success && res.data.html) {
    console.log("AJAX SUCCESS:", res.data); // 🔹 log dei dati ricevuti
    list.insertAdjacentHTML('beforeend', res.data.html);
    updateCounts(res.data.counts);
    updateResultsCounter(res.data.found_posts);
    
    const maxPages = Number(res.data.max_pages || 0);
    if (currentPage >= maxPages) toggleLoadButton('hide');
    else toggleLoadButton('show');
  } else if (reset) {
    console.log("AJAX EMPTY RESULT"); // 🔹 log se niente trovato
    list.innerHTML = '<div class="block-page-results__empty marg-top-80"><div class="size-h3 font-semibold">Nessun risultato trovato</div></div>';
    updateResultsCounter(0);
    toggleLoadButton('hide');
  }
}

function updateCounts(counts) {
  if (!counts) return;
  Object.entries(counts).forEach(([type, count]) => {
    const el = document.querySelector(`.filter-count[data-type="${type}"]`);
    if (el) el.textContent = count;
    console.log(`Count for ${type}: ${count}`); // 🔹 log conteggi
  });
}

function updateResultsCounter(total) {
  const counter = document.querySelector('.block-page-results__load .count');
  const list = document.querySelector('.block-page-results__list');
  if (!counter || !list) return;
  const shown = list.querySelectorAll('.block-page-results__item').length;
  counter.textContent = total > 0 ? `${shown} di ${total} risultati trovati` : `0 risultati trovati`;
}

function loadResults(reset = false) {
  if (typeof window.vegaAjax === 'undefined' || isLoading) return;

  if (controller) controller.abort();
  controller = new AbortController();

  if (reset) { currentPage = 1; }
  isLoading = true;
  toggleLoadButton('loading');

  const searchTerm = getSearchTerm();
  console.log(`LOAD RESULTS: search="${searchTerm}", type="${currentType}", page=${currentPage}`); // 🔹 log prima della fetch


  const params = new URLSearchParams({
    action: 'vega_search',
    search: getSearchTerm(),
    type: currentType,
    page: currentPage,
    _ajax_nonce: window.vegaAjax.nonce
  });

  fetch(window.vegaAjax.url, {
    method: 'POST',
    body: params,
    signal: controller.signal
  })
  .then(r => r.json())
  .then(res => {
    updateUI(res, reset);
    if (res.success) currentPage++;
  })
  .catch(err => {
    if (err.name !== 'AbortError') console.error("Errore ricerca:", err);
  })
  .finally(() => {
    isLoading = false;
  });
}

// Eventi
document.arrive('.block-page-banner__search', { existing: true, onceOnly: true }, form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const block = document.querySelector('.block-page-results');
    if (block) {
      block.classList.add('is-visible');
      block.scrollIntoView({ behavior: 'smooth' });
    }
    loadResults(true);
  });
});

document.arrive('.block-page-results__filter', { existing: true }, el => {
  el.addEventListener('click', () => {
    document.querySelectorAll('.block-page-results__filter').forEach(i => i.classList.remove('active'));
    el.classList.add('active');
    currentType = el.dataset.filter;
    console.log(`FILTER CLICKED: type="${currentType}", search="${getSearchTerm()}"`); // 🔹 log click filtro
    loadResults(true);
  });
});

document.arrive('.btn-load', { existing: true, onceOnly: true }, el => {
  el.addEventListener('click', () => loadResults(false));
});

// Auto-load solo se ?q= è presente nell'URL (es. link diretto a una ricerca)
document.arrive('.block-page-results', { existing: true, onceOnly: true }, block => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('q')) {
    block.classList.add('is-visible');
    loadResults(true);
  }
});